<script>

export default {
  props: {
    columns: {
      type: String
    },
    rows: {
      type: String
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-grid-layout'
      ]

      return classes.join(' ')
    }
  },
  watch: {
    columns () {
      this.$forceUpdate()
    },
    rows () {
      this.$forceUpdate()
    }
  },
  render (createElement) {
    
    let widths = this.columns ? this.columns.replace(/ /g, '').split(',') : []
    let heights = this.rows ? this.rows.replace(/ /g, '').split(',') : []
    let cells = this.$slots.default || []
    let columns = []
    let rows = []

    cells.sort((a, b) => {
      if (a.data && b.data) {
        if (a.data.attrs.row === b.data.attrs.row) {
          if (a.data.attrs.col === b.data.attrs.col) {
            return 0
          } else {
            return a.data.attrs.col > b.data.attrs.col ? 1 : -1
          }
        } else {
          return a.data.attrs.row > b.data.attrs.row ? 1 : -1
        }
      } else {
        return a.data ? 1 : -1
      }
    })

    let lastCol = -1
    let lastRow = -1

    cells.forEach((cell, index) => {
      if (!cell.data) return

      let column = cell.data.attrs.col ? parseInt(cell.data.attrs.col) : lastCol+1
      let row = cell.data.attrs.row ? parseInt(cell.data.attrs.row) : lastRow+1

      lastRow = row

      if (lastCol >= column) {
        lastCol = -1
      }

      while (lastCol < column) {
        ++lastCol
        
        let style = {}
        let colSpan
        let rowSpan

        if (widths[lastCol] && widths[lastCol].match(/\d+/)) {
          style.width = widths[lastCol] + 'px'
        }

        if (heights[lastRow] && heights[lastRow].match(/\d+/)) {
          style.height = heights[lastRow] + 'px'
        }

        if (lastCol === column) {
          let alignment = cell.data.attrs.verticalAlignment || cell.componentOptions.propsData.verticalAlignment
          
          if (alignment) {
            style.verticalAlign = alignment
          }

          columns.push(createElement('td', {style, colSpan, rowSpan}, [cell]))
        }
        else {
          columns.push(createElement('td', {style, colSpan, rowSpan}))
        }
      }
      
      if (index >= cells.length-1 || cell.data.attrs.row !== cells[index + 1].data.attrs.row) {
        rows.push(createElement('tr', {}, columns))

        columns = []
      }
    })
    
    return createElement('table', {class: this.classes, on: this.$listeners}, rows)
  },
  mounted () {

  }
}

</script>

<style lang="scss">

html {
  .web-grid-layout {
    display: table;
    border-spacing: 0;
  }

  .web-grid-layout > * {
    display: table-row;
  }

  .web-grid-layout > * > * {
    display: table-cell;
    padding: 0;
    vertical-align: middle;
  }

  /*
  .web-grid-layout > * > * > * {
    height: 100%;
  }
  */
}

</style>